import axios from 'axios'

export default () => {
  return axios.create({
    // baseURL: 'https://newcltts-d54c9a98a7f7.herokuapp.com/api/'
    baseURL: 'https://api.charlottetamilsangam.org/api/',
    // baseURL:'https://cltts.azurewebsites.net/api/'
    // baseURL:'http://localhost:8081/api/'
    //   baseURL: 'https://clttsapi.onrender.com/api/'
  })
}
